export const trimAndCompareStrings = (
  a: string = "",
  b: string = "",
): boolean => {
  return a.trim() === b.trim();
};
